import React from "react";

function HomeOut() {
  return (
    <div className="home">
      <div class="container">
        <div class="row align-items-center my-5">
          <div class="col-lg-5">
            <h1 class="title">Home</h1>
            <header className="21 Days">
                <p class="center">
                    Welcome to 21 days, a habit tracker. HIII
                </p>
            </header>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeOut;